__turbopack_context__.v({
  "continue_watching_row": "_pLjKG_continue_watching_row",
  "continue_watching_row__splide_arrow": "_pLjKG_continue_watching_row__splide_arrow",
  "continue_watching_row__title": "_pLjKG_continue_watching_row__title",
  "splide__arrow": "_pLjKG_splide__arrow",
  "splide__list": "_pLjKG_splide__list",
  "splide__slide": "_pLjKG_splide__slide",
});
